/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

window.DocumentsTable = {
  _gridApi: null,

  _gridOptions: {
    paginationPageSize: 10,
    headerHeight: 44,
    rowHeight: 44,
    suppressRowTransform: true,
    defaultColDef: {
      sortable: true,
      resizable: true
    },
    onGridSizeChanged(event) {
      event.api.sizeColumnsToFit();
      return $('.has-tip:not([data-selector]), [data-tooltip][title]:not(.has-tip):not([data-selector])').foundation('tooltip');
    },
    getRowHeight(params) {
      let k, numberOfDocs, v;
      let height = 1;
      if (params.data.name === "Submitted documents") {
        for (k in params.data) {
          v = params.data[k];
          if (typeof v === 'object') {
            numberOfDocs = v.submittedDocuments.length;
            if (numberOfDocs > height) { height = numberOfDocs; }
          }
        }

        if (height === 1) { return 44; } else { return (height * 20) + 30; }
      } else if (params.data.name === "Evaluation documents") {
        for (k in params.data) {
          v = params.data[k];
          if (typeof v === 'object') {
            numberOfDocs = v.evaluationDocuments.length;
            if (numberOfDocs > height) { height = numberOfDocs; }
          }
        }

        if (height === 1) { return 50 + (numberOfDocs * 25); } else { return (height * 25) + 50; }
      } else {
        return 44;
      }
    }
  },

  _renderCellValue(params) {
    let textColor;
    const columnName = params.colDef.field;
    const data = params.data[columnName];

    let cellValue = '-';

    if (data.hasOwnProperty('version')) {
      if (data.hasOwnProperty('boq')) {
        const tender_posting_id = DocumentsFinance._getQueryVariable('tender_posting_id');
        let {
          xls_url
        } = data;
        if (tender_posting_id) {
          xls_url = data.xls_url + `&tender_posting_id=${tender_posting_id}`;
        }

        cellValue = "Received V" + data.version;
        textColor = 'red';
        const random_id = parseInt(Math.random() * 1000000);
        cellValue = `
<div class='flexible-rolldown rolldown-auto float-right'>
<a class='button rolldown nano icon-btn pt-download' data-aria-expanded='true' data-dropdown='export-drop-${tender_posting_id}-${random_id}' aria-expanded='false'></a>
<ul aria-hidden='true' class='f-dropdown custom-dropdown-fixed pill-btn bid-dropdown' data-dropdown-content='true' id='export-drop-${tender_posting_id}-${random_id}' aria-hidden='true'>
<li><a href='${data.pdf_url}'><i class='pti pt-pdf'></i>PDF</a></li>
<li><a href='${data.without_price_pdf_url}'><i class='pti pt-pdf'></i>PDF(without price)</a></li>
<li><a href='${xls_url}'><i class='pti pt-excel'></i>XLS</a></li></ul>
</div>
<span class='pt-${textColor}'>${cellValue}</span>
`;
      } else {
        cellValue = "Accepted V" + data.version;
        textColor = 'green';
        cellValue = `<a class='button nano icon-btn pt-download has-tip tip-top float-right' data-tooltip title='${'Download'}' href='` + data.url + `'></a><span class='pt-${textColor}'>${cellValue}</span>`;
      }
    } else if (data.hasOwnProperty('fot')) {
      cellValue = "Received";
      textColor = 'red';
      cellValue = `<a class='button nano icon-btn pt-download has-tip tip-top float-right' data-tooltip title='${'Download'}' href='` + data.url + `'></a><span class='pt-${textColor}'>${cellValue}</span>`;
    } else if (data.hasOwnProperty('submittedDocuments')) {
      const submittedDocs = _.reduce(
        data.submittedDocuments,
        (memo, doc) => memo + "<li><span title='" + doc.title + "'>" + doc.title + "</span></li>",
        ""
      );

      if (submittedDocs === "") {
        cellValue = "-";
      } else {
        cellValue = `<a class='button nano icon-btn pt-download has-tip tip-top float-right' data-tooltip title='${'Download'}' href='` + data.submittedDocumentsZipUrl + "'></a>";
        cellValue += "<ul class='nomargin document-items-list'>" + submittedDocs + "</ul>";
      }
    } else if (data.hasOwnProperty('evaluationDocuments')) {
      const showDestroy = data.hasOwnProperty('newEvaluationDocumentUrl');
      const evaluationTemplate = _.template(
        `<li>
<a class='button nano icon-btn pt-download has-tip tip-top float-right'
data-tooltip
title='<%= 'Download' %>'
href='<%= doc.url %>'>
</a>
<% if(showDestroy) { %>
<div class='confirm-with-reveal'>
<a class='button nano icon-btn pt-delete has-tip tip-top float-right'
data-tooltip
data-method='delete'
data-confirm='<%= JSON.stringify({ title: 'Delete', body: 'Confirm' }) %>'
rel='nofollow'
title='<%= I18n.t('v4.document_versions.tooltips.delete-document') %>'
href='<%= doc.url %>'>
</a>
</div>
<% } %>
<span title='<%= doc.title %>'><%= doc.title %></span>
</li>`
      );

      const evaluationDocs = _.reduce(
        data.evaluationDocuments,
        (memo, doc) => memo + evaluationTemplate({ doc, showDestroy }),
        ""
      );

      if ((evaluationDocs === "") && data.newEvaluationDocumentUrl) {
        cellValue = "<a class='add-document-btn pt-blue button nano pt-upload data-reveal-id='reveal-id' data-reveal-ajax='true' href='" + data.newEvaluationDocumentUrl + "'>Upload</a>";
      } else {
        cellValue = "<ul class='nomargin document-items-list clear'>" + evaluationDocs + "</ul>";
        if (data.newEvaluationDocumentUrl) {
          cellValue += "<a class='add-document-btn xsmall-top-buffer pt-blue button nano pt-upload data-reveal-id='reveal-id' data-reveal-ajax='true' href='" + data.newEvaluationDocumentUrl + "'>Upload</a>";
        }
      }
    }

    return cellValue;
  },

  _appendDownloadButtons(columns) {
    return _.map(columns, function (column) {
      if (column.download_url) {
        const btn = `<a class='ag-header-button icon-btn button nano pt-download has-tip tip-top' data-tooltip title='${I18n.t('v4.document_versions.tooltips.download-bidders-documents', { company_name: column.name })}' href='${column.download_url}'></a>`;
        return $(`.ag-header-cell[col-id='${column.field}'] .ag-header-cell-text`).append(btn);
      }
    });
  },

  refreshTable() {
    const visibleBidders = BiddersUtils.getBidders('visible');
    const allGridColumns = this._gridApi.getAllGridColumns();

    let columnFields = _.map(allGridColumns, column => column.colDef.field);
    columnFields = _.without(columnFields, 'name');

    this._gridApi.setColumnsVisible(columnFields, false);

    const visibleColumnsFields = [];
    const visibleColumns = _.each(visibleBidders, bidderName => {
      const bidderColumn = _.select(allGridColumns, column => bidderName === column.colDef.headerName.split('<a')[0])[0];
      if (bidderColumn) {
        return visibleColumnsFields.push(bidderColumn.colDef.field);
      }
    });
    this._gridApi.setColumnsVisible(visibleColumnsFields, true);
    if ($("a[href='#documents_container']").parent().hasClass('active')) { return this._gridApi.sizeColumnsToFit(); }
  },

  initializeTable(data) {
    const columns = _.map(data.columns, column => {
      return { headerName: column.name, width: 250, cellClass: 'overflow-visible', suppressSizeToFit: true, field: column.field, cellRenderer: params => this._renderCellValue(params) };
    });

    const columnDefs = [
      { headerName: 'Document Name', field: 'name', minWidth: 250, pinned: 'left' }
    ].concat(columns);

    this._gridOptions.columnDefs = columnDefs;
    this._gridOptions.rowData = data.rows;

    const eGridDiv = document.querySelector('#documentsTable');
    this._gridApi = agGrid.createGrid(eGridDiv, this._gridOptions);
    this._gridOptions.api = this._gridApi;
    this.refreshTable();
    this._gridApi.addEventListener('gridSizeChanged', () => this._appendDownloadButtons(data.columns))
    this._gridApi.addEventListener('bodyScroll', () => this._appendDownloadButtons(data.columns))
  }
};
